import React, { useEffect, useState } from 'react';
import { Table, Button, Drawer, Space, Popconfirm, Card, Tooltip, Input } from 'antd';
import { PlusOutlined, EditOutlined, DeleteOutlined, SearchOutlined } from '@ant-design/icons';
import AddServiceType from './AddServiceType';
import { ServicetypeService } from '../../../Services/Manage/ServicetypeService';
import useMessage from 'antd/es/message/useMessage';
import dayjs from 'dayjs';

const getPermission = (link) => {
  try {
    const raw = localStorage.getItem("ome_permission");
    const parsed = JSON.parse(raw);
    const permissions = Array.isArray(parsed) ? parsed : JSON.parse(parsed);
    return permissions.find(p => p.link === link) || { add: false, edit: false, delete: false, read: false };
  } catch { return { add: false, edit: false, delete: false, read: false }; }
};

const ViewServiceType = () => {

    const perm = getPermission('/manage-services');
    const [data, setData] = useState([]);

    const [drawerOpen, setDrawerOpen] = useState(false);
    const [editingRecord, setEditingRecord] = useState(null);
    const [message, smsgContext] = useMessage();

    const [searchText, setSearchText] = useState("");

    const getAllServices = async () => {
        try {
            const request = await ServicetypeService.getAllServicesType();
            setData(
                request.data.map((item, index) => ({
                    ...item,
                    si_no: index + 1
                }))
            );

        } catch (error) {
            console.error(error);

        }
    };
    useEffect(() => {
        getAllServices();
    }, [])

    // Open drawer for Add
    const handleAdd = () => {
        setEditingRecord(null);
        setDrawerOpen(true);
    };

    // Open drawer for Edit
    const handleEdit = (record) => {
        setEditingRecord(record);
        setDrawerOpen(true);
    };

    // Handle form submit (add or edit)
    const handleSubmit = (values) => {
        if (editingRecord) {
            // Edit existing
            setData((prev) =>
                prev.map((item) =>
                    item.key === editingRecord.key ? { ...item, ...values } : item
                )
            );
            getAllServices();
        } else {
            // Add new
            const newRecord = {
                key: Date.now().toString(),
                ...values,
                added_on: new Date().toISOString().slice(0, 16).replace("T", " "),
                updated_on: new Date().toISOString().slice(0, 16).replace("T", " "),
            };
            setData((prev) => [...prev, newRecord]);
            getAllServices();
        }
        setDrawerOpen(false);
    };


    const handleDelete = async (key) => {
 

        try {
            const req = await ServicetypeService.deleteServicesType(key);
      

            if (req.status) {
                message.success(req.message)
                getAllServices();
                setData((prev) => prev.filter((item) => item.key !== key));
            } else {
                message.error(req.message)
            }
        } catch (error) {
            console.log(error);
        }
    };



    const filteredData = data.filter((item) => {
  const search = searchText.toLowerCase();

  return (
    item.type_name?.toLowerCase().includes(search) ||
    item.type_code?.toLowerCase().includes(search) ||
    item.note?.toLowerCase().includes(search) ||
    item.added_by?.toLowerCase().includes(search)
  );
});

    const columns = [
        { title: 'S. No', dataIndex: 'si_no', key: 'si_no' },
        { title: 'Service Type Name', dataIndex: 'type_name', key: 'type_name' },
        { title: 'Type Code', dataIndex: 'type_code', key: 'type_code' },
        {
            title: 'Note',
            dataIndex: 'note',
            key: 'note',
            width: 180,
            render: (value) => (
                <Tooltip title={value || "-"}>
                <div
                    style={{
                    maxWidth: 180,
                    whiteSpace: "nowrap",
                    overflow: "hidden",
                    textOverflow: "ellipsis",
                    cursor: "pointer",
                    }}
                >
                    {value || "-"}
                </div>
                </Tooltip>
            ),
            },
        { title: 'Added By', dataIndex: 'added_by', key: 'added_by' },
        { title: 'Updated On', dataIndex: 'updated_on', key: 'updated_on', render: (value) => dayjs(value).format("DD-MM-YYYY hh:mm A") },
        { title: 'Added On', dataIndex: 'added_on', key: 'added_on', render: (value) => dayjs(value).format("DD-MM-YYYY hh:mm A") },
        {
            title: 'Actions',
            key: 'actions',
    render: (_, record) => (
                <Space>
                    <Tooltip title={!perm.edit ? "You don't have permission to edit" : ""}>
                        <Button
                            size='large'
                            icon={<EditOutlined />}
                            onClick={() => handleEdit(record)}
                            disabled={!perm.edit}
                        />
                    </Tooltip>
                    <Popconfirm
                        title="Are you sure to delete?"
                        onConfirm={() => handleDelete(record.id)}
                        disabled={!perm.delete}
                    >
                        <Tooltip title={!perm.delete ? "You don't have permission to delete" : ""}>
                            <Button size='large' danger icon={<DeleteOutlined />} disabled={!perm.delete} />
                        </Tooltip>
                    </Popconfirm>
                </Space>
            ),
        },
    ];

    return (
        <Card
            title='Manage Service Type'
      extra={
                <Tooltip title={!perm.add ? "You don't have permission to create" : ""}>
                    <Button
                        size='large'
                        type="primary"
                        icon={<PlusOutlined />}
                        onClick={handleAdd}
                        disabled={!perm.add}
                    >
                        Add Service Type
                    </Button>
                </Tooltip>
            }>

            <Table
                columns={columns}
                dataSource={data}
                // 
                pagination={true}
                scroll={{ x: 'max-content' }}
            />
            {smsgContext}

            <Drawer
                title={editingRecord ? 'Edit Service Type' : 'Add Service Type'}
                width={400}
                open={drawerOpen}
                onClose={() => setDrawerOpen(false)}
                destroyOnClose
            >
                <AddServiceType
                    initialValues={editingRecord}
                    onSubmit={handleSubmit}
                    onCancel={() => setDrawerOpen(false)}
                />
            </Drawer>
        </Card>
    );
};

export default ViewServiceType;
